var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApprovals(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F6F6F6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3221_55328)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M17.1109 19.1816C18.3488 17.9581 18.8813 16.6631 19.8959 15.6469C20.3584 15.1831 20.5266 14.4831 20.6894 13.8059C20.8284 13.2278 21.1191 12 21.7497 12C22.4997 12 23.9997 12.25 23.9997 14.5453C23.9997 15.8709 23.1872 16.6144 22.9597 17.5H26.1388C27.1822 17.5 27.9947 18.3672 27.9997 19.3156C28.0022 19.8763 27.7638 20.4797 27.3922 20.8528L27.3888 20.8566C27.6963 21.5856 27.6463 22.6066 27.0978 23.3397C27.3691 24.1491 27.0956 25.1431 26.5859 25.6759C26.7203 26.2259 26.6559 26.6941 26.3938 27.0706C25.7559 27.9872 24.1753 28 22.8384 28H22.7497C21.2409 28 20.0059 27.45 19.0134 27.0084C18.5134 26.7869 17.8628 26.5122 17.3681 26.5031C17.2699 26.5013 17.1762 26.461 17.1074 26.3909C17.0385 26.3208 17 26.2264 17 26.1281V19.4478C17 19.3983 17.0098 19.3493 17.0288 19.3036C17.0479 19.2579 17.0758 19.2164 17.1109 19.1816V19.1816Z",
    fill: "#162930"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.25 19H12.75C12.5511 19 12.3603 19.079 12.2197 19.2197C12.079 19.3603 12 19.5511 12 19.75V27.25C12 27.4489 12.079 27.6397 12.2197 27.7803C12.3603 27.921 12.5511 28 12.75 28H15.25C15.4489 28 15.6397 27.921 15.7803 27.7803C15.921 27.6397 16 27.4489 16 27.25V19.75C16 19.5511 15.921 19.3603 15.7803 19.2197C15.6397 19.079 15.4489 19 15.25 19ZM14 26.75C13.8517 26.75 13.7067 26.706 13.5833 26.6236C13.46 26.5412 13.3639 26.4241 13.3071 26.287C13.2503 26.15 13.2355 25.9992 13.2644 25.8537C13.2934 25.7082 13.3648 25.5746 13.4697 25.4697C13.5746 25.3648 13.7082 25.2933 13.8537 25.2644C13.9992 25.2355 14.15 25.2503 14.287 25.3071C14.4241 25.3639 14.5412 25.46 14.6236 25.5833C14.706 25.7067 14.75 25.8517 14.75 26C14.75 26.1989 14.671 26.3897 14.5303 26.5303C14.3897 26.671 14.1989 26.75 14 26.75V26.75Z",
    fill: "#162930"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3221_55328"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprovals);
export default __webpack_public_path__ + "static/media/Approvals.aaca60c0.svg";
export { ForwardRef as ReactComponent };